import { ALLOWED_EXTENSIONS, ALLOWED_MIME_TYPES, ERROR_FILE_SIZE, ERROR_FILE_TYPE, ERROR_FILE_TYPE_SYSTEM, ID_REQUEST_NAME_STORAGE, PARAM_URL_IDREQUEST } from "@/constants/commons";
import { RecordItemMap, ResultMasterMap } from "@/interfaces/table-master";
import type { components } from "@/types/maestros-api";
import { getEnvironmentVariable } from "./environment";
import { getParamUrl } from "./url.utils";

export type SupportedMime =
  | "application/pdf"
  | "image/jpeg"
  | "image/png"
  | "application/msword"
  | "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
  | "application/vnd.ms-excel"
  | "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

export interface FileValidationResult {
  isValid: boolean;
  error?: string;
  file?: File;
}

export const getMimeType = (filename: string = ""): SupportedMime | "" => {
  const ext = filename.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "pdf":
      return "application/pdf";
    case "doc":
      return "application/msword";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "xls":
      return "application/vnd.ms-excel";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    default:
      return "";
  }
};


export const getUUID = () => {
	return ('10000000-1000-4000-8000-100000000000').replace(/[018]/g, c =>
		(parseInt(c) ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> (parseInt(c) / 4)).toString(16)
	)
}

export const getRecordsTableMasterByCode = (resultMasterMap: ResultMasterMap[] | null = [], codeTableMaster: number): RecordItemMap[] => {
  const group = resultMasterMap?.find(
    ({ code }) => code === codeTableMaster
  );

  return group?.records ?? [];
};

export const getValueRecordTableMasterBycode = (resultMasterMap: ResultMasterMap[] | null = [],codeTableMaster: number, codeRecord:number):string => {
	return getRecordsTableMasterByCode(resultMasterMap, codeTableMaster).find(({ code }) => code === codeRecord)?.value || "";
}

/**
 * Calcula la edad exacta basándose en una cadena de fecha (DD/MM/YYYY)
 * @param birthDate Ejemplo: "02/01/2001"
 * @returns número de años
 */
export const calculateAge = (birthDate: string): number => {
  const SEPARATE_DATE = '/';
  const [day, month, year] = birthDate.split(SEPARATE_DATE).map(Number);
  const today = new Date();
  const birthDateObj = new Date(year, month - 1, day);

  let age = today.getFullYear() - birthDateObj.getFullYear();
  const monthDifference = today.getMonth() - birthDateObj.getMonth();
  const MONTH_DIFFERENCE_ZERO = 0;
  if (monthDifference < MONTH_DIFFERENCE_ZERO || (monthDifference === MONTH_DIFFERENCE_ZERO && today.getDate() < birthDateObj.getDate())) {
    age--;
  }

  return age;
};

export const getIdRequest = (): string => {
  const idRequest = getParamUrl(PARAM_URL_IDREQUEST);
  return idRequest ? idRequest : sessionStorage.getItem(ID_REQUEST_NAME_STORAGE) ?? "";
}

export const polizaRecordsByCode = (
  polizasData: components["schemas"]["PolicyListResponse"] | null | undefined,
  codigoPoliza: number | string
): components["schemas"]["PolicyItem"][] => {
  if (!polizasData?.datos) return [];
  const code = typeof codigoPoliza === "string" ? Number(codigoPoliza) : codigoPoliza;
  return polizasData.datos.filter((item) => item.codigo === code);
};

export function binaryToBase64(binary: Uint8Array): string {
  try {
    const binaryString = Array.from(binary)
      .map(byte => String.fromCharCode(byte))
      .join('');
    return btoa(binaryString);
  } catch (error) {
    console.error('Error al convertir binario a Base64:', error);
    throw error;
  }
}

export function sanitizeObservationInput(value: string): string {
  return value.replace(/[^a-zA-Z0-9, “¿\?:\+'.'"\s]/g, "");
}

  export const validateAndSetFile = (file: File | null): FileValidationResult => {
  if (!file) {
    return { isValid: false };
  }

  const maxSizeFile = Number(getEnvironmentVariable('VITE_APP_MAX_SIZE_FILE_RESULT', "")) || 20 * 1024 * 1024;
  const ext = file.name.split('.').pop()?.toLowerCase();

  if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
    return {
      isValid: false,
      error: ERROR_FILE_TYPE
    };
  }

  if (file.type && !ALLOWED_MIME_TYPES.includes(file.type)) {
    return {
      isValid: false,
      error: ERROR_FILE_TYPE_SYSTEM
    };
  }

  if (file.size > maxSizeFile) {
    return {
      isValid: false,
      error: ERROR_FILE_SIZE
    };
  }

  return {
    isValid: true,
    file
  };
};

export const getIdFileStorage = (fileName: string, idRecord: string = ""): string => {
  const ext = fileName.split('.').pop() || '';
  const nameWithoutExt = fileName.substring(0, fileName.lastIndexOf('.')) || fileName;
  const idExtra = idRecord ? `-${idRecord}` : '';
  return `${nameWithoutExt}-${getUUID()}${idExtra}.${ext}`;
}